export enum MEET_SERVICES {
  VONAGE = 'VONAGE',
  VONAGE_V2 = 'VONAGE_V2',
  VONAGE_EXPRESS = 'VONAGE_EXPRESS',
  ZOOM = 'ZOOM',
}
